<template>
    <div>
        <v-container v-if="!ready" fluid>
            <v-progress-linear indeterminate color="primary" class="mt-4" />
        </v-container>
        <QuoteMilestonesLegacy
            v-else-if="useLegacy"
            :project="project"
            :users="users"
        />
        <QuoteMilestonesGroups v-else :project="project" :users="users" />
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import API from '@/services/api'

export default {
    name: 'QuoteMilestones',
    props: {
        project: Object,
        users: Array,
    },
    components: {
        QuoteMilestonesLegacy: () =>
            import('@/components/Milestones/QuoteMilestonesLegacy.vue'),
        QuoteMilestonesGroups: () =>
            import('@/components/Milestones/QuoteMilestonesGroups.vue'),
    },
    data: () => ({
        ready: false,
        useLegacy: false,
    }),
    async mounted() {
        try {
            this.useLegacy = await this.detectLegacyMode()
        } catch (error) {
            this.setErrorItems({
                name: this.$options.name,
                message: error.message,
            })
            this.useLegacy = false
        } finally {
            this.ready = true
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        hasScopeGroups() {
            return (
                Array.isArray(this.project && this.project.scopeGroups) &&
                this.project.scopeGroups.length > 0
            )
        },
        hasLegacyRowOrder() {
            return (
                Array.isArray(
                    this.project && this.project.milestonesRowOrder
                ) && this.project.milestonesRowOrder.length > 0
            )
        },
        async hasLegacyCostMilestones() {
            const quotes = this.project && this.project.quotes
            if (!quotes || quotes.length === 0) {
                return false
            }
            for (const quote of quotes) {
                const quoteId = String(quote).split('/')[0]
                if (!quoteId) {
                    continue
                }
                const costs = await API.getCosts(quoteId)
                const found = (costs || []).some(
                    cost =>
                        Array.isArray(cost.milestones) &&
                        cost.milestones.length > 0
                )
                if (found) {
                    return true
                }
            }
            return false
        },
        async detectLegacyMode() {
            // New module already in use for this project
            if (this.hasScopeGroups()) {
                return false
            }
            // Old flat module left row order
            if (this.hasLegacyRowOrder()) {
                return true
            }
            // Old progress recorded on costs without scopes
            return await this.hasLegacyCostMilestones()
        },
    },
}
</script>
